import React from "react";

/**
 * Legend explaining the color codes used for the "DUE DATE" column
 * on the Supplies Expenses "for approval" tab. Rendered inline within
 * the same filter row (next to "Total Expenses") for a single-row layout.
 * Colors/classes are shared with Table.js via PurchaseOrders.css so the
 * legend and the table cell can never fall out of sync visually.
 */
export default function DeadlineLegend() {
  return (
    <div className="deadline-legend d-flex align-items-center flex-wrap">
      <span className="me-3 legend-label">Deadline:</span>

      <span className="legend-item">
        <span className="legend-swatch deadline-red" />
        1-2 Days
      </span>

      <span className="legend-item">
        <span className="legend-swatch deadline-orange" />
        3-4 Days
      </span>

      <span className="legend-item">
        <span className="legend-swatch deadline-yellow" />
        5-7 Days
      </span>

      <span className="legend-item">
        <span className="legend-swatch deadline-green" />
        8+ Days
      </span>
    </div>
  );
}